webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(119)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/full_map.1c5bbdc.jpg";

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hacking_area_scaled.7d66c4a.png";

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hackntu-logo.90bac1a.png";

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FirebaseApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VueFireDB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appconfig__ = __webpack_require__(4);




var FirebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_1__appconfig__["a" /* default */].firebase_config);

var VueFireDB = FirebaseApp.database();

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  "data-v-a8f919ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = {
	"RETRY_DELAY_IF_RATE_LIMITED": 5000
};

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(962),
  /* scopeId */
  "data-v-2417ae7f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(120)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  "data-v-6b022bd2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Home__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_MapView_vue__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_MapView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_MapView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_hackingmap_ListView_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_hackingmap_ListView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_home_hackingmap_ListView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_hackingmap_FullMapView__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_hackingmap_FullMapView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_home_hackingmap_FullMapView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AdminView__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AdminView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AdminView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MentorView__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MentorView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_MentorView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AskMentor__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AskMentor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AskMentor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LiveAwards__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LiveAwards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_LiveAwards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Speaker__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Speaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Speaker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Expo__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Expo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Expo__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '*', redirect: '/projects' }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home_Home___default.a,
    children: [{ path: 'map', component: __WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_MapView_vue___default.a, name: 'Map' }, { path: 'projects', component: __WEBPACK_IMPORTED_MODULE_4__components_home_hackingmap_ListView_vue___default.a }, { path: 'full_map', component: __WEBPACK_IMPORTED_MODULE_5__components_home_hackingmap_FullMapView___default.a }, { path: '', redirect: '/projects' }]
  }, { path: '/admin', component: __WEBPACK_IMPORTED_MODULE_6__components_AdminView___default.a }, { path: '/mentor', component: __WEBPACK_IMPORTED_MODULE_7__components_MentorView___default.a }, { path: '/askMentor', component: __WEBPACK_IMPORTED_MODULE_8__components_AskMentor___default.a }, { path: '/liveAwards', component: __WEBPACK_IMPORTED_MODULE_9__components_LiveAwards___default.a }, { path: '/speaker', component: __WEBPACK_IMPORTED_MODULE_10__components_Speaker___default.a }, { path: '/expo', component: __WEBPACK_IMPORTED_MODULE_11__components_Expo___default.a }]
}));

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var appconfig = {
  general: {
    sponsor: false,
    discord: false,
    tutorial_for_non_login: false
  },
  'firebase_config': {
    apiKey: 'AIzaSyCK5_1a6NghhFZxL4a6csnrzHLkiouOQM4',
    authDomain: 'hacking-map.firebaseapp.com',
    databaseURL: 'https://hacking-map.firebaseio.com',
    projectId: 'hacking-map',
    storageBucket: 'hacking-map.appspot.com',
    messagingSenderId: '729739716516'
  },
  event_info: {
    start_date: new Date('Mon Jul 21 2017 00:09:00 GMT+0800 (CST)'),
    end_date: new Date('Mon Jul 23 2017 00:17:00 GMT+0800 (CST)')
  },
  map: {
    map_width: 842,
    map_height: 1286,
    table_coor: null }
};

var coorX = [341, 384, 430, 523, 569, 614, 660];
var coorY = [301, 364, 429, 492, 557, 621, 685, 748, 812, 876, 940, 1004, 1068, 1132, 1196];

function generateTableCoor(xs, ys) {
  var tableCoor = {
    0: {
      no: 0,
      x: -150,
      y: 400
    }
  };
  for (var i = 0; i < xs.length * ys.length; i++) {
    tableCoor[i + 1] = {
      no: i + 1,
      x: xs[i % xs.length],
      y: ys[Math.floor(i / xs.length) % ys.length]
    };
  }
  return tableCoor;
}
appconfig.map.table_coor = generateTableCoor(coorX, coorY);

/* harmony default export */ __webpack_exports__["a"] = (appconfig);

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)
__webpack_require__(106)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(963),
  /* scopeId */
  "data-v-28192220",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_index_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__);














__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon___default.a);

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);




var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appconfig__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_banner_Banner_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_banner_Banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_banner_Banner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sponsor_vue__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sponsor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Sponsor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_Home_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading_vue__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Loading_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      config: __WEBPACK_IMPORTED_MODULE_0__appconfig__["a" /* default */],
      loading: true,
      ready: false
    };
  },
  mounted: function mounted() {},

  methods: {
    loaded: function loaded() {
      var _this = this;

      console.log('loaded');
      this.ready = true;
      setTimeout(function () {
        _this.loading = false;
      }, 1500);
    }
  },
  components: {
    banner: __WEBPACK_IMPORTED_MODULE_1__components_banner_Banner_vue___default.a,
    sponsor: __WEBPACK_IMPORTED_MODULE_2__components_Sponsor_vue___default.a,
    home: __WEBPACK_IMPORTED_MODULE_3__components_home_Home_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_Loading_vue___default.a
  }
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin',
  mounted: function mounted() {
    this.$emit('loaded');
  },
  data: function data() {
    return {
      rules: {
        title: [{ required: true, message: '請輸入公告標題', trigger: 'blur' }, { min: 3, max: 15, message: '需介於 3 到 15 個字元', trigger: 'blur' }],
        detail: [{ required: false, message: '需介於 1 到 50 個字元', trigger: 'blur' }, { min: 1, max: 50, message: '需介於 1 到 50 個字元', trigger: 'change' }]
      },
      pwd: ''
    };
  },
  firebase: function firebase() {
    return {
      title: {
        source: __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__["a" /* FirebaseApp */].database().ref('/public/announcement/title'),
        asObject: true,
        readyCallback: function readyCallback() {
          console.log('[admin] Fetched `announcement.title`!');
        }
      },
      detail: {
        source: __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__["a" /* FirebaseApp */].database().ref('/public/announcement/detail'),
        asObject: true,
        readyCallback: function readyCallback() {
          console.log('[admin] Fetched `announcement.detail`!');
        }
      }
    };
  },

  computed: {
    announcement: function announcement() {
      return {
        title: this.title['.value'],
        detail: this.detail['.value']
      };
    },
    titleLength: function titleLength() {
      return this.announcement.title ? this.announcement.title.length : 0;
    },
    detailLength: function detailLength() {
      return this.announcement.detail ? this.announcement.detail.length : 0;
    }
  },
  methods: {
    updateAnnouncement: function updateAnnouncement() {
      var _this = this;

      var updates = {
        'title': this.announcement.title,
        'detail': this.announcement.detail,
        'pwd': this.pwd
      };

      __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__["a" /* FirebaseApp */].database().ref('/public/announcement/').update(updates).then(function () {
        _this.$message({ message: '成功更新', type: 'success' });
      }).then(function () {
        _this.$message({ message: '成功更新', type: 'success' });
      }).catch(function (e) {
        _this.$message.error('更新失敗');
      });
    }
  },
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue___default.a
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'askMentor',
  mounted: function mounted() {
    this.$emit('loaded');
  },
  data: function data() {
    return {
      question: {
        title: '',
        mentorId: '',
        projectId: '',
        description: ''
      }
    };
  },
  firebase: function firebase() {
    var that = this;
    return {
      questions: {
        source: __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__["a" /* FirebaseApp */].database().ref('/mentor/questions'),
        asObject: true,
        readyCallback: function readyCallback() {
          console.log('[askMentor] Fetched `mentor.questions`!');
        },
        cancelCallback: function cancelCallback(e) {
          console.log('[askMentor] Fetched `mentor.questions` cancel!', e);
          that.$message.error('讀取資料失敗');
        }
      }
    };
  },

  computed: {},
  methods: {
    askQuestion: function askQuestion() {
      var _this = this;

      this.$firebaseRefs.questions.push(this.question).then(function () {
        _this.resetQuestion();
        _this.$message({ message: '新增成功', type: 'success' });
      }).catch(function (e) {
        _this.$message.error('新增失敗');
      });
    },
    resetQuestion: function resetQuestion() {
      this.question = {
        title: '',
        mentorId: '',
        projectId: '',
        description: ''
      };
    }
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'expo',
  data: function data() {
    return {
      table: ''
    };
  },

  firebase: {
    posts: {
      source: __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__["a" /* FirebaseApp */].database().ref('/posts/'),
      readyCallback: function readyCallback() {
        console.log('[Expo] Loaded');
        this.$emit('loaded');
      }
    }
  },
  computed: {
    matchedPosts: function matchedPosts() {
      var _this = this;

      return this.posts.filter(function (post) {
        return post.table === _this.table;
      });
    }
  },
  methods: {
    clear: function clear() {
      console.log('clear()');
      this.table = null;
    }
  },
  watch: {
    $route: function $route() {
      if (this.$route.query['table']) {
        this.table = this.$route.query.table;
      }
    }
  },
  components: {
    postsummary: __WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary___default.a
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'intro',
  data: function data() {
    return {
      url: 'https://hackmd.io/s/H1_0-tkBZ',
      isLoaded: false
    };
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'liveAwards',
  mounted: function mounted() {
    this.$emit('loaded');
  },
  data: function data() {
    return {
      label: '企業獎即時分流',
      awards: ['北市交通局', 'HITCON', '經濟部', '中信Jarvis', '中信資料家', '農委會', '威盛OLAMI', '微軟'],
      regex: /#?\d{3}$/g
    };
  },
  firebase: function firebase() {
    var that = this;
    return {
      posts: {
        source: __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].database().ref('/posts/'),
        readyCallback: function readyCallback() {
          console.log('[HackingMap] Fetched `posts`!');
          that.$emit('loaded');
        }
      }
    };
  },

  computed: {
    postAwards: function postAwards() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.compact(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatten(this.posts.map(function (m) {
        return m.awards;
      })));
    },
    awardsLength: function awardsLength() {
      var awardsLength = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(this.postAwards);
      return this.awards.map(function (m) {
        return awardsLength[m] ? awardsLength[m].length : 0;
      });
    },
    postWithoutHost: function postWithoutHost() {
      var regex = this.regex || /#?\d{3}$/g;

      return this.posts.filter(function (post) {
        var pass = regex.test(post.host);
        console.log(post.host, pass);
        return !pass;
      }).map(function (post) {
        return post.name + ':' + post.host;
      });
    }
  },
  methods: {}
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  props: {
    ready: Boolean
  },
  data: function data() {
    return {
      msg: 'Welcome!'
    };
  }
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mentor',
  mounted: function mounted() {
    this.$emit('loaded');
  },
  data: function data() {
    return {
      mentorId: ''
    };
  },
  firebase: function firebase() {
    return {
      questions: {
        source: __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].database().ref('/mentor/questions'),
        readyCallback: function readyCallback() {
          console.log('[mentor] Fetched `mentor.questions`!');
        }
      }
    };
  },

  computed: {
    mentorsQuestions: function mentorsQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(this.questions, function (gb) {
        return gb.mentorId;
      });
    },
    mentorQuestions: function mentorQuestions() {
      return this.mentorsQuestions[this.mentorId];
    }
  },
  methods: {
    markRead: function markRead(qkey) {
      var _this = this;

      var updates = {};
      updates[qkey + '/read'] = true;

      this.$firebaseRefs.questions.update(updates).then(function () {
        _this.$message({ message: '標注讀取', type: 'success' });
      }).catch(function (e) {
        _this.$message.error('更新失敗');
      });
    }
  }
});

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_x_audio_vue__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_x_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_x_audio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Airtable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Airtable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Airtable__);




var base = new __WEBPACK_IMPORTED_MODULE_2_Airtable___default.a({
  apiKey: 'keyTOhP8DLjUFtOFz'
}).base('appcs0kkOF4h36C7J');
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'speaker',
  created: function created() {
    var _this = this;

    this.getRequest();
    var requestTimer = setInterval(function () {
      if (_this.playList.length === 0) _this.getRequest();
    }, 10000);
    var playTimer = setInterval(function () {
      _this.checkPlay();
    }, 1000);
    console.log(this.$refs.xAudio);
  },
  data: function data() {
    return {
      msg: 'HackNTU Minor Hackathon Broadcast System',
      translatorUrl: 'http://www.bing.com/translator/api/language/Speak?',
      locale: 'zh-CN',
      gender: 'Male',
      media: 'audio/mp3',
      text: '測試',
      select: {
        locale: ['zh-CN', "zh-HK", "zh-TW", "en-US", "en-AU", "en-CA", "en-GB", "en-IN"],
        gender: ['Male', 'Female']
      },
      request: [],
      playList: [],
      playing: false,
      checkTime: ''
    };
  },

  computed: {
    audioSrc: function audioSrc() {
      return this.translatorUrl + 'locale=' + this.locale + '&' + 'gender=' + this.gender + '&' + 'media=' + this.media + '&' + 'text=' + this.text;
    },
    allowed: function allowed() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.request, function (record) {
        return record['已審核'] && !record['已播放'];
      });
    }
  },
  watch: {
    playList: function playList() {
      var _this2 = this;

      if (this.playList.length > 0) {
        var play = this.playList.shift();
        console.log(play);
        this.text = play['廣播內容'];
        this.played(play.id);
        this.$nextTick(function () {
          _this2.$refs.xAudio.play();
        });
      }
    }
  },
  methods: {
    played: function played(rid) {
      base('廣播').update(rid, {
        "已播放": true
      }, function (err, record) {
        if (err) {
          console.error(err);
          return;
        }
        console.log('已播放', record.get('標題'), record.get('廣播內容'), record.get('已播放'));
      });
    },
    checkPlay: function checkPlay() {
      var _this3 = this;

      console.log('checkPlay()');
      var now = new Date();
      var play = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.allowed, function (record) {
        var playTime = new Date(record['播放時間']);
        _this3.checkTime = now.toLocaleTimeString() + ' | ' + playTime.toLocaleTimeString();
        var sameDate = now.toLocaleDateString() === playTime.toLocaleDateString();
        var sameTime = now.toLocaleTimeString() === playTime.toLocaleTimeString();
        return sameTime && sameTime;
      });
      this.playList = this.playList.concat(play);
    },
    getRequest: function getRequest() {
      var _this4 = this;

      console.log('getRequest()');
      var request = [];
      base('廣播').select({
        maxRecords: 10,
        view: "Main View"
      }).eachPage(function page(records, fetchNextPage) {
        request = request.concat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(records, function (record) {
          return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(record.fields, 'id', record.id);
        }));

        fetchNextPage();
      }, function (err) {
        if (err) {
          console.error(err);
          return;
        }

        _this4.request = request;
      });
    }
  },
  components: {
    'x-audio': __WEBPACK_IMPORTED_MODULE_0__components_x_audio_vue___default.a
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Airtable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Airtable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Airtable__);



var db = new __WEBPACK_IMPORTED_MODULE_0_Airtable___default.a({ apiKey: 'keyC0ndMttA3rW78D' }).base('appTGjW5XhtMQa2t0');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sponsor',
  data: function data() {
    return {
      isFetching: true,
      records: []
    };
  },
  created: function created() {
    this.syncAirtable();
  },

  methods: {
    syncAirtable: function syncAirtable() {
      var vm = this;
      vm.isFetching = true;
      vm.records = [];
      db('Sponser').select({
        view: 'Grid view',
        filterByFormula: '{顯示} = TRUE()',
        sort: [{ field: '順序', direction: 'asc' }]
      }).eachPage(function page(records, fetchNextPage) {
        records.forEach(function (record) {
          record.fields.id = record.id;
          vm.records.push(record.fields);
        });
        fetchNextPage();
      }, function done(err) {
        vm.isFetching = false;
        if (err) {
          console.error('[Sponser] Airtable fetch fail:', err);return;
        }
      });
    }
  }
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_banner_OAuthLogin__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_banner_OAuthLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_banner_OAuthLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'banner',
  data: function data() {
    return {
      visible: false,
      loginBtnText: '登入',
      dialogTitle: '登入 HackingMap',
      dropdownItems: {
        0: {
          text: 'HackingMap for Expo',
          link: '#/expo'
        },
        1: {
          text: '加入Discord',
          link: 'https://discord.gg/9Zf8sYR'
        },
        2: {
          text: 'Memtor 列表',
          link: 'https://airtable.com/shr95DPYrCMQWe1l0'
        },
        3: {
          text: 'Memtor 駐點',
          link: 'https://airtable.com/shrrVlkKjBnYOGXkY'
        },
        4: {
          text: '企業獎入選名單',
          link: 'https://airtable.com/shrECgq5cGgL9UJvJ'
        },
        5: {
          text: 'HackNTU官網',
          link: 'https://hackntu.tumblr.com/tagged/intro'
        },
        6: {
          text: 'HackingMap導覽',
          link: 'https://hackmd.io/s/H1_0-tkBZ'
        }
      }
    };
  },

  components: {
    oauthlogin: __WEBPACK_IMPORTED_MODULE_0__components_banner_OAuthLogin___default.a
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.loginBtnText = user.providerData[0].displayName || user.email.split('@')[0];
        _this.dialogTitle = '歡迎登入, ' + user.providerData[0].displayName || user.email.split('@')[0];
      } else {
        _this.loginBtnText = '登入';
        _this.dialogTitle = '登入 HackingMap';
      }
    });
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__ = __webpack_require__(2);




var max480 = window.matchMedia('(max-device-width: 480px)').matches;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'oauthlogin',
  data: function data() {
    return {
      user: null,
      userRef: null,
      enableEmailPassLoginFlag: false,
      enableGoogleLoginFlag: false,
      enableFacebookLoginFlag: true,
      email: null,
      pwd: null,
      showEmailPassField: false,
      showResetBtn: false,
      isPhone: max480
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().onAuthStateChanged(function (U) {
      _this.showResetBtn = false;
      if (U) {
        _this.user = {
          uid: U.uid,
          email: U.email || U.providerData[0].email,
          displayName: U.providerData[0].displayName || U.email.split('@')[0],
          photoURL: U.providerData[0].photoURL || 'http://i.imgur.com/1Us6LVp.png'
        };
        if (!_this.user.uid || !_this.user.email || !_this.user.displayName || !_this.user.photoURL) {
          console.warn('[OAuthLogin] 使用者資料異常?', _this.user);
        }
        _this.setUserToDatabase(_this.user.uid, _this.user.email, _this.user.displayName, _this.user.photoURL);
        console.log('[OAuthLogin] 使用者登入了: ', _this.user.displayName);
      } else {
        _this.user = null;
        console.log('[OAuthLogin] 使用者未登入');
      }
    });
  },

  methods: {
    setUserToDatabase: function setUserToDatabase(uid, email, displayName, photoURL) {
      __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].database().ref('users/' + uid).set({
        uid: uid,
        displayName: displayName,
        email: email,
        photoURL: photoURL
      }).catch(function (err) {
        return console.error('[OAuthLogin] 使用者資料寫入錯誤:', err.message);
      });
    },
    signinWithGoogle: function signinWithGoogle() {
      var _this2 = this;

      var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      var promise = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().signInWithPopup(provider);
      promise.then(function (result) {
        console.log('Google 登入成功: ', result);
        _this2.$message({ message: 'Google 登入成功', type: 'success' });
      }).catch(function (err) {
        console.log('Google 登入錯誤: ', err.code, err.message);
        _this2.$notify({
          title: 'Google 登入錯誤',
          message: '\u5EFA\u8B70\u4F7F\u7528\u96FB\u8166\u7248Chrome\u767B\u5165\u3002\uFF08\u932F\u8AA4\u539F\u56E0\uFF1A' + err.message + '\uFF09',
          type: 'warning',
          duration: 0
        });
      });
    },
    signinWithFB: function signinWithFB() {
      var _this3 = this;

      var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.FacebookAuthProvider();
      var promise = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().signInWithPopup(provider);
      promise.then(function (result) {
        console.log('Facebook 登入成功: ', result);
        _this3.$message({ message: 'Facebook 登入成功', type: 'success' });
      }).catch(function (err) {
        console.log('Facebook 登入錯誤: ', err.code, err.message);
        _this3.$notify({
          title: 'Facebook 登入錯誤',
          message: '\u8ACB\u5617\u8A66\u4F7F\u7528\u96FB\u8166\u7248\u7684Google Chrome\u767B\u5165\u3002\uFF08\u932F\u8AA4\u539F\u56E0\uFF1A' + err.message + '\uFF09',
          type: 'warning',
          duration: 0
        });
      });
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().signOut();
      this.email = '';
      this.pwd = '';
    },
    signInWithEmailAndPassword: function signInWithEmailAndPassword() {
      var _this4 = this;

      var promise = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().signInWithEmailAndPassword(this.email, this.pwd);
      promise.catch(function (err) {
        console.log('[SignInOrSignUp.vue] 登入出錯了：', err);
        switch (err.code) {
          case 'auth/wrong-password':
            _this4.$message({ message: '抱歉，您提供的email或密碼不正確。，若須重設密碼請點選右下角的「登入遇到問題？」。', type: 'warning' });break;
          case 'auth/invalid-email':
            _this4.$message({ message: '抱歉，您提供的email無效，請填入有效的email。', type: 'warning' });break;
          case 'auth/user-disabled':
            _this4.$message({ message: '抱歉，您的帳號已被暫時停用，詳情請聯絡 lawrencechou1024「AT」gmail.com ', type: 'warning' });break;
          case 'auth/user-not-found':
            _this4.$message({ message: '抱歉，資料庫中並沒有使用者紀錄，請先註冊。', type: 'warning' });break;
          default:
            _this4.$message.error({ message: '登入發生未預期的錯誤:' + err.message });
        }
      });
    },
    signup: function signup() {
      var _this5 = this;

      var promise = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().createUserWithEmailAndPassword(this.email, this.pwd);
      promise.catch(function (err) {
        console.log('[SignInOrSignUp.vue] 註冊出錯了：', err);
        switch (err.code) {
          case 'auth/email-already-in-use':
            _this5.$message({ message: '此Email帳號已註冊，若須重設密碼請點選右下角的「登入遇到問題？」。', type: 'warning' });break;
          case 'auth/invalid-email':
            _this5.$message({ message: '抱歉，您提供的email無效，請填入有效的email。', type: 'warning' });break;
          case 'auth/operation-not-allowed':
            _this5.$message({ message: 'Email註冊服務已終止，詳情請聯絡 lawrencechou1024「AT」gmail.com ', type: 'warning' });break;
          case 'auth/weak-password':
            _this5.$message({ message: '密碼強度過低，請嘗試更複雜的密碼。', type: 'warning' });break;
          default:
            _this5.$message.error({ message: '登入發生未預期的錯誤:' + err.message });
        }
      });
    },
    sendResetMail: function sendResetMail() {
      var _this6 = this;

      var promise = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().sendPasswordResetEmail(this.email);
      promise.then(function () {
        alert('密碼重置連結已寄到' + _this6.email + '，請前往確認。');
        console.log('[SignInOrSignUp.vue] 密碼重置連結已寄到', _this6.email);
      }).catch(function (err) {
        console.log('>> sendPasswordResetEmail()出錯了：', err);
        switch (err.code) {
          case 'auth/invalid-email':
            alert('無效的email');break;
          case 'auth/user-not-found':
            alert('此email尚未註冊');break;
          default:
            alert(err);
        }
      });
    }
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'announcement',
  data: function data() {
    return {
      enableHistory: false,
      announcements: [],
      showHistory: false,
      clickIndex: null
    };
  },

  firebase: {
    title: {
      source: __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__["a" /* FirebaseApp */].database().ref('/public/announcement/title'),
      asObject: true
    },
    detail: {
      source: __WEBPACK_IMPORTED_MODULE_0__service_firebase_js__["a" /* FirebaseApp */].database().ref('/public/announcement/detail'),
      asObject: true
    }
  },
  computed: {
    displayIndex: function displayIndex() {
      return this.clickIndex === null ? this.announcements.length - 1 : this.clickIndex;
    }
  },
  methods: {
    HHMM: function HHMM(date) {
      var d = new Date(date);
      var HH = d.getHours();
      var MM = d.getMinutes();
      return HH + ':' + MM;
    }
  }
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_MyPosts_vue__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_MyPosts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_MyPosts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Intro_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appconfig__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hackingmap',
  data: function data() {
    return {
      user: null,
      showDialog: false,
      showIntro: false,
      query: '',
      scope: 'all',
      sortKey: 'timestamp',
      path: this.$route.path
    };
  },
  firebase: function firebase() {
    var _this = this;

    var that = this;
    return {
      posts: {
        source: __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].database().ref('/posts/'),
        readyCallback: function readyCallback() {
          console.log('[HackingMap] Fetched `posts`!');

          if (_this.user === null && __WEBPACK_IMPORTED_MODULE_4__appconfig__["a" /* default */].general.tutorial_for_non_login) {
            _this.showIntro = true;
          }
          that.$emit('loaded');
        }
      }
    };
  },

  computed: {
    myPostTitle: function myPostTitle() {
      return (this.user.providerData[0].displayName || this.user.email.split('@')[0]) + '的專案';
    },
    filteredSortedPosts: function filteredSortedPosts() {
      var key = this.sortKey;
      return this.filteredPosts.sort(function (a, b) {
        if (key === 'timestamp') {
          return a.timestamp === b.timestamp ? a.name > b.name : a.timestamp > b.timestamp ? -1 : 1;
        } else {
          var lenA = a[key] === undefined ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(a[key]).length;
          var lenB = b[key] === undefined ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(b[key]).length;
          return lenA === lenB ? a.name > b.name : lenA > lenB ? -1 : 1;
        }
      });
    },
    filteredPosts: function filteredPosts() {
      var _this2 = this;

      if (!this.query) {
        return this.posts;
      }
      switch (this.scope) {
        case 'tags':
          return this.posts.filter(function (post) {
            if (post.tags) {
              return post.tags.reduce(function (a, b) {
                return '$$' + a + b;
              }, '').toLowerCase().includes(_this2.query.toLowerCase());
            }
          });
        case 'teammates':
          return this.posts.filter(function (post) {
            if (post.teammates) {
              return post.teammates.reduce(function (a, b) {
                return '$$' + a + b;
              }, post.host).toLowerCase().includes(_this2.query.toLowerCase());
            }
          });
        case 'awards':
          return this.posts.filter(function (post) {
            if (post.awards) {
              return post.awards.reduce(function (a, b) {
                return '$$' + a + b;
              }, '').toLowerCase().includes(_this2.query.toLowerCase());
            }
          });
        case 'name':
          return this.posts.filter(function (post) {
            return post.name.toLowerCase().includes(_this2.query.toLowerCase());
          });
        case 'desc':
          return this.posts.filter(function (post) {
            return (post.desc || '').toLowerCase().includes(_this2.query.toLowerCase());
          });
        case 'all':
          return this.posts.filter(function (post) {
            var everything = post.name + '$$' + post.desc;
            everything += (post.tags || []).reduce(function (a, b) {
              return a + b + '$$';
            }, '');
            everything += (post.teammates || []).reduce(function (a, b) {
              return a + b + '$$';
            }, post.host);
            return everything.toLowerCase().includes(_this2.query.toLowerCase());
          });
        default:
          return this.posts;
      }
    }
  },
  watch: {
    $route: function $route(to, from) {
      console.log('[HackingMap] go to:', to.fullPath);
      this.path = to.fullPath;
      var query = to.query.query;
      if (query) {
        console.log('[watch $route] set query: query');
        this.query = query;
      } else {}
    },
    scope: function scope(value) {
      this.query = value === 'teammates' ? '#' : '';
    }
  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().onAuthStateChanged(function (user) {
      if (user) {
        _this3.user = user;
      } else {
        _this3.user = null;
      }
    });
  },

  methods: {},
  components: {
    myposts: __WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_MyPosts_vue___default.a,
    intro: __WEBPACK_IMPORTED_MODULE_3__components_Intro_vue___default.a
  }
});

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_HackingMap_vue__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_HackingMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_home_HackingMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Schedule_vue__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Schedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_Schedule_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    hackingmap: __WEBPACK_IMPORTED_MODULE_0__components_home_HackingMap_vue___default.a,
    announcement: __WEBPACK_IMPORTED_MODULE_1__components_home_Announcement_vue___default.a,
    schedule: __WEBPACK_IMPORTED_MODULE_2__components_home_Schedule_vue___default.a
  }
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appconfig__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Airtable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Airtable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_Airtable__);




var db = new __WEBPACK_IMPORTED_MODULE_1_Airtable___default.a({ apiKey: 'keyC0ndMttA3rW78D' }).base('appTGjW5XhtMQa2t0');
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'schedule',
  data: function data() {
    return {
      msg: '行程表',
      currentEventIndex: null,
      records: [],
      active: null,
      isFetching: true,
      default_icon: 'circle-o',
      num: 10
    };
  },
  created: function created() {
    this.syncAirtable();
    setInterval(this.syncAirtable, 10 * 60 * 1000);
    setInterval(this.checkCurrentEventIndex, 10 * 1000);
  },
  updated: function updated() {
    var component = this.$refs['step' + this.currentEventIndex + 'ref'][0];
    if (component) {
      var px = this.$refs['step' + this.currentEventIndex + 'ref'][0].$el.offsetTop - 16;
      this.$refs['scroll-area'].scrollTop = px;
    }
  },

  methods: {
    syncAirtable: function syncAirtable() {
      var vm = this;
      vm.isFetching = true;
      vm.records = [];
      db('Schedule').select({
        view: 'Grid view',
        filterByFormula: '{顯示} = TRUE()',
        sort: [{ field: '開始時間', direction: 'asc' }]
      }).eachPage(function page(records, fetchNextPage) {
        records.forEach(function (record) {
          record.fields.id = record.id;
          vm.records.push(record.fields);
        });
        fetchNextPage();
      }, function done(err) {
        vm.isFetching = false;
        vm.checkCurrentEventIndex();
        console.log('[Schedule] Sync Airtable every 10 mins');
        if (err) {
          console.error(err);return;
        }
      });
    },
    checkCurrentEventIndex: function checkCurrentEventIndex() {
      for (var index = 0; index < this.records.length; index++) {
        var i = this.records[index];
        var j = this.records[index + 1] || {};
        var iStarted = new Date(i['開始時間']) < new Date();
        var iEnded = i['結束時間'] ? new Date(i['結束時間']) < new Date() : false;
        var jStarted = new Date(j['開始時間']) < new Date();
        var jEnded = j['結束時間'] ? new Date(j['結束時間']) < new Date() : false;

        if (iStarted && !jStarted) {
          if (!iEnded && !jEnded) {
            this.updateCurrentEventIndex(index);
          } else if (iEnded && !jEnded) {
            this.updateCurrentEventIndex(index + 1);
          }
        }
      }
    },
    updateCurrentEventIndex: function updateCurrentEventIndex(index) {
      if (this.currentEventIndex !== index) {
        this.$message({
          message: '\u63A5\u4E0B\u4F86\uFF0C' + this.records[index]['大標題'],
          type: 'success'
        });
        this.currentEventIndex = index;
      }
    },
    formatDates: function formatDates(date1, date2) {
      var d1 = new Date(date1);
      var MM1 = d1.getMonth() + 1;
      var DD1 = d1.getDate();
      var HH1 = ('0' + d1.getHours()).slice(-2);
      var MIN1 = ('0' + d1.getMinutes()).slice(-2);
      var d2 = new Date(date2);
      var HH2 = ('0' + d2.getHours()).slice(-2);
      var MIN2 = ('0' + d2.getMinutes()).slice(-2);
      var isDuringHackathon = __WEBPACK_IMPORTED_MODULE_0__appconfig__["a" /* default */].event_info.start_date < d1 && d1 < __WEBPACK_IMPORTED_MODULE_0__appconfig__["a" /* default */].event_info.end_date;
      if (isDuringHackathon) {
        return date2 ? HH1 + ':' + MIN1 + ' ~ ' + HH2 + ':' + MIN2 : HH1 + ':' + MIN1;
      } else {
        return date2 ? MM1 + '/' + DD1 + ' ' + HH1 + ':' + MIN1 + ' ~ ' + HH2 + ':' + MIN2 : MM1 + '/' + DD1 + ' ' + HH1 + ':' + MIN1;
      }
    },
    clipSubtitle: function clipSubtitle(text) {
      if (text) {
        var row1 = text.slice(0, 13);
        var row2 = text.slice(13, 25);
        return row1 + (row2 ? '</br>' + row2 + '...' : '');
      }
    }
  }
});

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appconfig__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_firebase_js__ = __webpack_require__(2);






var db = __WEBPACK_IMPORTED_MODULE_2__service_firebase_js__["a" /* FirebaseApp */].database();
var AWARDS = ['北市交通局', 'HITCON', '經濟部', '中信Jarvis', '中信資料家', '農委會', '威盛OLAMI', '微軟'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor',
  data: function data() {
    return {
      tables: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1__appconfig__["a" /* default */].map.table_coor),
      awardOptions: AWARDS,
      awardsTooltip: '僅供初步線上調查，若超出20組上線將再調整。<br/>調查填寫至3pm止，3-4pm收紙本報名，6pm前<br/>公告確認錄取組別。',
      awardsDeadline: 'Sat Jul 22 2017 15:00:00 GMT+0800 (CST)',
      awardsDisable: false,
      newPost: {
        name: null,
        host: '',
        contact: '',
        desc: null,
        iframe: null,
        git: '',
        table: null,
        status: null,
        tags: [],
        teammates: [],
        awards: []
      },
      rules: {
        name: [{ required: true, message: '請輸入專案名稱', trigger: 'blur' }, { min: 3, max: 15, message: '需介於 3 到 15 個字元', trigger: 'blur' }],

        table: [{ required: true, message: '請選擇專案所在位置', trigger: 'change' }],
        status: [{ required: true, message: '請選擇專案目前狀態', trigger: 'change' }],
        award: [{ required: true, message: '請選擇是否參與企業獎', trigger: 'change' }],
        desc: [{ required: true, message: '需介於 1 到 100 個字元', trigger: 'blur' }, { min: 1, max: 100, message: '需介於 1 到 100 個字元', trigger: 'change' }]
      },
      inputNewTag: '',
      inputNewTeammate: '#',
      inputVisible: false,
      inputVisibleTeammate: false,
      isLoading: true,
      isLoadingIframe: false,
      loadIframe: false,
      loadingUpdate: false,
      tagList: ['資訊安全', '公民參與', '開放資料', '機器學習', '社群', '社會服務', '物聯網', '資料分析', '消費者', '資料視覺化', '數位人文', '人工智慧', '虛擬實境', '教育', '金融']
    };
  },

  props: {
    postData: {
      type: Object,
      required: true
    }
  },
  computed: {
    postKey: function postKey() {
      return this.postData['.key'];
    },
    tagListTooltip: function tagListTooltip() {
      var _this = this;

      return this.tagList.filter(function (f) {
        return f.indexOf(_this.inputNewTag) > -1;
      }).toString().replace(/,/g, '<br/>');
    },
    wordCountMsg: function wordCountMsg() {
      return this.newPost.desc ? '\u5C08\u6848\u7C21\u4ECB (' + this.newPost.desc.length + '/100\u5B57)' : '專案簡介 (0/100字)';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.restoreForm(this.postData);

    if (!this.isAfterDeadline()) {
      setInterval(function () {
        _this2.awardsDisable = _this2.isAfterDeadline();
      }, 3000);
    }
  },

  methods: {
    isAfterDeadline: function isAfterDeadline() {
      console.log('[Editor] isAfterDeadline: ', new Date() > new Date(this.awardsDeadline));
      return new Date() > new Date(this.awardsDeadline);
    },
    restoreForm: function restoreForm(postData) {
      console.log('[Editor] 載入post舊資料', postData.name);
      this.newPost.name = postData.name;
      this.newPost.host = postData.host || '';
      this.newPost.contact = postData.contact || '';

      this.newPost.desc = postData.desc || '';
      this.newPost.iframe = postData.iframe || '';
      this.newPost.git = postData.git || '';
      this.newPost.table = postData.table || '';
      this.newPost.status = postData.status || '';
      this.newPost.award = postData.award || '';
      this.newPost.tags = postData.tags || [];
      this.newPost.teammates = postData.teammates || [];
      this.newPost.awards = postData.awards || [];
      this.isLoading = false;
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.submitPost();
        } else {
          _this3.$message.error({ message: '資料格式不全' });
          return false;
        }
      });
    },
    submitPost: function submitPost() {
      var _this4 = this;

      this.loadingUpdate = true;

      var p = this.newPost;
      var promise = this.updatePostForCurrentUser(this.postKey, p.name, p.host, p.contact, p.desc, p.iframe, p.git, p.table, p.status, p.award, p.tags, p.teammates, p.awards);
      promise.then(function () {
        _this4.loadingUpdate = false;
        _this4.$message({ message: '更新成功', type: 'success' });
        _this4.$emit('cancel');
        console.log('[Editor.vue] post成功更新', _this4.postkey);
      }).catch(function (err) {
        _this4.loadingUpdate = false;
        _this4.$message.error('更新發生錯誤' + err.message);
      });
    },
    updatePostForCurrentUser: function updatePostForCurrentUser(postKey, name, host, contact, desc, iframe, git, table, status, award, tags, teammates, awards) {
      var u = __WEBPACK_IMPORTED_MODULE_2__service_firebase_js__["a" /* FirebaseApp */].auth().currentUser;
      if (!u.uid || !postKey) {
        throw new Error('Invalid currentUser or postkey', u, postKey);
      } else {
        var updates = {};
        var path1 = '/posts/' + postKey + '/';
        var path2 = '/user-posts/' + u.uid + '/' + postKey + '/';
        updates[path1 + 'name'] = name;
        updates[path2 + 'name'] = name;
        updates[path1 + 'host'] = host;
        updates[path2 + 'host'] = host;
        updates[path1 + 'contact'] = contact;
        updates[path2 + 'contact'] = contact;
        updates[path1 + 'desc'] = desc;
        updates[path2 + 'desc'] = desc;
        updates[path1 + 'iframe'] = iframe;
        updates[path2 + 'iframe'] = iframe;
        updates[path1 + 'git'] = git.replace('https://github.com/', '');
        updates[path2 + 'git'] = git.replace('https://github.com/', '');
        updates[path1 + 'table'] = Number(table) > 105 ? '0' : table;
        updates[path2 + 'table'] = Number(table) > 105 ? '0' : table;
        updates[path1 + 'status'] = status;
        updates[path2 + 'status'] = status;
        updates[path1 + 'award'] = award;
        updates[path2 + 'award'] = award;
        updates[path1 + 'tags'] = tags;
        updates[path2 + 'tags'] = tags;
        updates[path1 + 'teammates'] = teammates;
        updates[path2 + 'teammates'] = teammates;
        updates[path1 + 'awards'] = awards;
        updates[path2 + 'awards'] = awards;
        updates[path1 + 'timestamp'] = new Date();
        updates[path2 + 'timestamp'] = new Date();

        return db.ref().update(updates);
      }
    },
    handleDeleteTag: function handleDeleteTag(tag) {
      this.newPost.tags.splice(this.newPost.tags.indexOf(tag), 1);
    },
    handleDeleteTeammate: function handleDeleteTeammate(teammate) {
      this.newPost.teammates.splice(this.newPost.teammates.indexOf(teammate), 1);
    },
    showNewTagInput: function showNewTagInput() {
      var _this5 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this5.$refs.saveTagInput.$refs.input.focus();
      });
    },
    showNewTeammateInput: function showNewTeammateInput() {
      var _this6 = this;

      this.inputVisibleTeammate = true;
      this.$nextTick(function (_) {
        _this6.inputNewTeammate = '#';
        _this6.$refs.saveTeammateInput.$refs.input.focus();
      });
    },
    handleNewTagConfirm: function handleNewTagConfirm() {
      var inputNewTag = this.inputNewTag;
      if (inputNewTag) {
        this.newPost.tags.push(inputNewTag.slice(0, 10));
      }
      this.inputVisible = false;
      this.inputNewTag = '';
    },
    handleNewTeammateConfirm: function handleNewTeammateConfirm() {
      var inputNewTeammate = this.inputNewTeammate;
      if (inputNewTeammate) {
        this.newPost.teammates.push(inputNewTeammate.slice(0, 4));
      }
      this.inputVisibleTeammate = false;
      this.inputNewTeammate = '';
    }
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appconfig__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fullmapview',
  data: function data() {
    return {
      map: __WEBPACK_IMPORTED_MODULE_0__appconfig__["a" /* default */].map,
      panZoomObj: null,
      svgPanZoomOpt: {
        viewportSelector: '.svg-pan-zoom_viewport',
        panEnabled: true,
        controlIconsEnabled: false,
        dblClickZoomEnabled: true,
        mouseWheelZoomEnabled: true,
        preventMouseEventsDefault: true,
        zoomScaleSensitivity: 0.4,
        minZoom: 0.9,
        maxZoom: 5,
        fit: true
      }
    };
  },
  mounted: function mounted() {
    console.log('[FullMapView] mounted');
    this.panZoomObj = __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom___default()(this.$refs.svg, this.svgPanZoomOpt);
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_postdetail__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_postdetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_postdetail__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'listview',
  data: function data() {
    return {
      dialogVisible: false,
      dialogPostKey: null
    };
  },

  props: ['filteredPosts'],
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {} else {
        _this.$message('登入後可投票歐 👉 ');
      }
    });
  },

  watch: {
    $route: function $route(val) {
      var projectID = val.query['id'];
      if (projectID) {
        this.showDialog(projectID);
      } else {}
    }
  },
  methods: {
    showDialog: function showDialog(key) {
      this.dialogPostKey = key;
      this.dialogVisible = true;
    },
    hideDialog: function hideDialog() {
      this.dialogVisible = false;
    },
    getPost: function getPost(key) {
      for (var index in this.filteredPosts) {
        var obj = this.filteredPosts[index];
        if (obj['.key'] === key) {
          return obj;
        }
      }
      return null;
    }
  },
  components: {
    postsummary: __WEBPACK_IMPORTED_MODULE_1__components_home_hackingmap_postsummary___default.a,
    postdetail: __WEBPACK_IMPORTED_MODULE_2__components_home_hackingmap_postdetail___default.a
  }
});

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appconfig__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_pan_zoom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_pan_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_pan_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_postsummary__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_postsummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_postsummary__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapview',
  created: function created() {},
  data: function data() {
    return {
      map: __WEBPACK_IMPORTED_MODULE_1__appconfig__["a" /* default */].map,
      panZoomObj: null,
      svgPanZoomOpt: {
        viewportSelector: '.svg-pan-zoom_viewport',
        panEnabled: true,
        controlIconsEnabled: false,
        dblClickZoomEnabled: true,
        mouseWheelZoomEnabled: true,
        preventMouseEventsDefault: true,
        zoomScaleSensitivity: 0.4,
        minZoom: 0.9,
        maxZoom: 5,
        fit: true
      },
      clicked: null,
      blinkStatus: '',
      focus: ''
    };
  },

  props: ['filteredPosts'],
  watch: {
    filteredPosts: function filteredPosts(val, oldVal) {
      var _this = this;

      this.$nextTick(function () {
        _this.setSvgPanZoom();
      });
    },
    $route: function $route(to, from) {
      this.focus = to.query.focus;
      this.resetPanZoom();
    }
  },
  mounted: function mounted() {
    console.log('[MapView] mounted');
    this.setSvgPanZoom();
  },

  computed: {
    tablePosts: function tablePosts() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(this.filteredPosts, function (gb) {
        return gb.table;
      });
    }
  },
  updated: function updated() {
    console.log('[MapView] updated');
  },

  methods: {
    setFocus: function setFocus(index) {
      console.log('setFocus(' + index + ')');
      this.focus = index;
    },
    setSvgPanZoom: function setSvgPanZoom() {
      var _this2 = this;

      this.panZoomObj = __WEBPACK_IMPORTED_MODULE_2_svg_pan_zoom___default()(this.$refs.svg, this.svgPanZoomOpt);
      console.log('[MapView] setSvgPanZoom() TRUE');

      this.$nextTick(function () {
        console.log('$nextTick(()');
        _this2.focus = _this2.$route.query.focus;
      });
    },
    getX: function getX(table) {
      var x = this.map.table_coor[Number(table)].x;
      return x || 10;
    },
    getY: function getY(table) {
      var y = this.map.table_coor[Number(table)].y;
      return y || 10;
    },
    getNoSeatXY: function getNoSeatXY(xy, index) {
      var gutter = 30;
      var cols = 3;
      switch (xy) {
        case 'dx':
          return index % cols * gutter;
        case 'dy':
          return Math.floor(index / cols) * gutter;
        default:
          return 0;
      }
    },
    onClick: function onClick(tableNo) {
      this.clicked = tableNo;
    },
    getColor: function getColor(status) {
      switch (status) {
        case '提案':
          return 'statue_proposal';
        case '徵人':
          return 'statue_recruit';
        case '趕工':
          return 'statue_hacking';
        case '完工':
          return 'statue_demo';
        case '放棄':
          return 'statue_giveup';
        default:
          return 'status_avalible';
      }
    },
    getStatus: function getStatus(status) {
      switch (status) {
        case '徵人':
          return 'recruit';
        case '趕工':
          return 'hacking';
        case '完工':
          return 'demo';
        case '放棄':
          return 'giveup';
        default:
          return 'avalible';
      }
    },
    getTableStatus: function getTableStatus(table) {
      return table.map(function (m) {
        return m.status;
      });
    },
    setBlinkStatus: function setBlinkStatus(set, status) {
      console.log('setBlinkStatus(' + set + ', ' + status + ')');
      if (set) {
        this.blinkStatus = status;
      } else {
        this.blinkStatus = '';
      }
    },
    resetPanZoom: function resetPanZoom() {
      console.log('[MapView] resetPanZoom()');
      this.panZoomObj.resetZoom();
      this.panZoomObj.resetPan();
    }
  },
  components: {
    postsummary: __WEBPACK_IMPORTED_MODULE_3__components_home_hackingmap_postsummary___default.a
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_hackingmap_Editor_vue__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_hackingmap_Editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_home_hackingmap_Editor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__ = __webpack_require__(2);




var dbRef = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["b" /* VueFireDB */].ref('/');
var userPostsRef = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["b" /* VueFireDB */].ref('user-posts');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'myposts',
  data: function data() {
    return {
      user: __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().currentUser,
      newPostTitle: '',
      editingPost: null,
      isFetching: true
    };
  },

  firebase: function firebase() {
    return {
      myPosts: {
        source: userPostsRef.child(this.user.uid),
        readyCallback: function readyCallback(_) {
          this.isFetching = false;
        }
      }
    };
  },
  methods: {
    toggleEditor: function toggleEditor(postKey) {
      if (postKey === this.editingPost) {
        this.editingPost = null;
      } else {
        this.editingPost = postKey;
      }
    },
    newPostForCurrentUser: function newPostForCurrentUser() {
      var _this = this;

      var u = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().currentUser;
      if (this.newPostTitle && u) {
        var postData = {
          name: this.newPostTitle,
          uid: u.uid,
          author: u.email,
          host: '',
          contact: '',
          starCount: 0,
          heartCount: 0,
          timestamp: new Date(),
          version: 1,
          desc: '超酷project',

          iframe: '',
          git: '',
          table: 0,
          status: '趕工',
          award: '無',
          teammates: [],
          tags: ['自訂標籤1', '自訂標籤2']
        };
        var newPostKey = userPostsRef.push().key;
        var updates = {};
        updates['/posts/' + newPostKey] = postData;
        updates['/user-posts/' + u.uid + '/' + newPostKey] = postData;
        dbRef.update(updates).then(function () {
          console.log('[MyPosts] 完成新增操作:', updates);
          _this.newPostTitle = '';
          _this.toggleEditor(newPostKey);
        }).catch(function (err) {
          console.error('[MyPosts] 新增操作失敗！', err.message);
        });
      }
    },
    removePostForCurrentUser: function removePostForCurrentUser(post) {
      var u = __WEBPACK_IMPORTED_MODULE_1__service_firebase_js__["a" /* FirebaseApp */].auth().currentUser;
      if (u) {
        var updates = {};
        updates['/posts/' + post['.key']] = null;
        updates['/user-posts/' + u.uid + '/' + post['.key']] = null;
        dbRef.update(updates).then(function () {
          console.log('[MyPosts.vue] 完成移除操作:', updates);
        });
      } else {
        console.error('請先登入！', u);
      }
    }
  },
  components: {
    editor: __WEBPACK_IMPORTED_MODULE_0__components_home_hackingmap_Editor_vue___default.a
  }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'postdetail',
  data: function data() {
    return {
      loadIframe: true,
      isLoading: true,

      default_iframe: '',
      msg: '抱歉，你的瀏覽器不支援iframe'
    };
  },

  computed: {
    postKey: function postKey() {
      return this.post['.key'] || null;
    },
    src: function src() {
      return this.loadIframe ? this.post.iframe || this.default_iframe : null;
    },
    wrapBackground: function wrapBackground() {
      if (this.isLoading) {
        return 'loading-bg';
      } else {
        return this.post.iframe ? 'load-fail-bg' : 'no-iframe-bg';
      }
    },
    starCount: function starCount() {
      return this.post.stars ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.post.stars).length : '0';
    },
    heartCount: function heartCount() {
      return this.post.hearts ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.post.hearts).length : '0';
    },
    isStaredByMe: function isStaredByMe() {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser) {
        var uid = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;

        if (this.post.stars) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.post.stars).includes(uid);
        }
      }
      return false;
    },
    isLovedByMe: function isLovedByMe() {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser) {
        var uid = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;

        if (this.post.hearts) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.post.hearts).includes(uid);
        }
      }
      return false;
    }
  },
  watch: {
    isOpen: function isOpen(_isOpen) {
      if (!_isOpen) {
        this.loadIframe = false;
      } else {
        this.loadIframe = true;
        this.isLoading = true;
      }
    }
  },
  methods: {
    goMap: function goMap(tableNo) {
      this.$emit('closeDialog');
      this.$router.push('/map?focus=' + tableNo);
    },
    toggleStar: function toggleStar() {
      if (!__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser) {
        alert('請先登入');
        return;
      }
      var globalPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/posts/' + this.postKey);
      var userPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/user-posts/' + this.authorId + '/' + this.postKey);
      var uid = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;
      this.togglePostStarForCurrentUser(globalPostRef, uid);
      this.togglePostStarForCurrentUser(userPostRef, uid);
    },
    toggleHeart: function toggleHeart() {
      if (!__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser) {
        alert('請先登入');
        return;
      }
      var globalPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/posts/' + this.postKey);
      var userPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/user-posts/' + this.authorId + '/' + this.postKey);
      var uid = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;
      this.togglePostHeartForCurrentUser(globalPostRef, uid);
      this.togglePostHeartForCurrentUser(userPostRef, uid);
    },
    togglePostStarForCurrentUser: function togglePostStarForCurrentUser(postRef, uid) {
      postRef.child('stars').child(uid).transaction(function (val) {
        if (val) {
          val = null;
        } else {
          val = true;
        }
        return val;
      }, function (error, committed, snapshot) {
        if (error) {
          console.log('[Card.vue] Transaction failed abnormally!', error);
        } else if (!committed) {
          console.log('[Card.vue] Aborted the transaction.');
        } else {
          console.log('[Card.vue] Star toggled for ' + snapshot.val());
        }
      });
    },
    togglePostHeartForCurrentUser: function togglePostHeartForCurrentUser(postRef, uid) {
      postRef.child('hearts').child(uid).transaction(function (val) {
        if (val) {
          val = null;
        } else {
          val = true;
        }
        return val;
      }, function (error, committed, snapshot) {
        if (error) {
          console.log('[Card.vue] Heart transaction failed abnormally!', error);
        } else if (!committed) {
          console.log('[Card.vue] Aborted the heart transaction.');
        } else {
          console.log('[Card.vue] Heart toggled for ' + snapshot.val());
        }
      });
    }
  },
  props: {
    post: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean
    }
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'postsummary',
  data: function data() {
    return {
      currentUser: null
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.currentUser = user;
      } else {
        _this.currentUser = null;
      }
    });
  },

  props: {
    title: {
      type: String,
      default: 'No title'
    },
    subtitle: {
      type: String,
      default: 'No subtitle'
    },
    description: {
      type: String,
      default: 'No description'
    },
    table: {
      type: Number,
      required: false
    },
    postKey: {
      type: String
    },
    authorId: {
      type: String
    },
    stars: {
      type: Object,
      default: null
    },
    hearts: {
      type: Object,
      default: null
    },

    tags: {
      type: Array
    },
    host: {
      type: String
    }
  },
  computed: {
    starCount: function starCount() {
      return this.stars ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stars).length : '0';
    },
    heartCount: function heartCount() {
      return this.hearts ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.hearts).length : '0';
    },
    isStaredByMe: function isStaredByMe() {
      if (this.currentUser) {
        var uid = this.currentUser.uid;

        if (this.stars) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stars).includes(uid);
        }
      }
      return false;
    },
    isLovedByMe: function isLovedByMe() {
      if (this.currentUser) {
        var uid = this.currentUser.uid;

        if (this.hearts) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.hearts).includes(uid);
        }
      }
      return false;
    }
  },
  methods: {
    goMap: function goMap(tableNo) {
      this.$router.push('/map?focus=' + tableNo);
    },
    toggleStar: function toggleStar() {
      if (!this.currentUser) {
        alert('請先登入');
        return;
      }
      var globalPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/posts/' + this.postKey);
      var userPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/user-posts/' + this.authorId + '/' + this.postKey);
      var uid = this.currentUser.uid;
      this.togglePostStarForCurrentUser(globalPostRef, uid);
      this.togglePostStarForCurrentUser(userPostRef, uid);
    },
    toggleHeart: function toggleHeart() {
      if (!this.currentUser) {
        alert('請先登入');
        return;
      }
      var globalPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/posts/' + this.postKey);
      var userPostRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/user-posts/' + this.authorId + '/' + this.postKey);
      var uid = this.currentUser.uid;
      this.togglePostHeartForCurrentUser(globalPostRef, uid);
      this.togglePostHeartForCurrentUser(userPostRef, uid);
    },
    togglePostStarForCurrentUser: function togglePostStarForCurrentUser(postRef, uid) {
      postRef.child('stars').child(uid).transaction(function (val) {
        if (val) {
          val = null;
        } else {
          val = true;
        }
        return val;
      }, function (error, committed, snapshot) {
        if (error) {
          console.log('[Card.vue] Transaction failed abnormally!', error);
        } else if (!committed) {
          console.log('[Card.vue] Aborted the transaction.');
        } else {
          console.log('[Card.vue] Star toggled for ' + snapshot.val());
        }
      });
    },
    togglePostHeartForCurrentUser: function togglePostHeartForCurrentUser(postRef, uid) {
      postRef.child('hearts').child(uid).transaction(function (val) {
        if (val) {
          val = null;
        } else {
          val = true;
        }
        return val;
      }, function (error, committed, snapshot) {
        if (error) {
          console.log('[Card.vue] Heart transaction failed abnormally!', error);
        } else if (!committed) {
          console.log('[Card.vue] Aborted the heart transaction.');
        } else {
          console.log('[Card.vue] Heart toggled for ' + snapshot.val());
        }
      });
    }
  }
});

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-audio',
  props: {
    audioSrc: String
  },
  data: function data() {
    return {
      autoplay: false
    };
  },

  computed: {
    audio: function audio() {
      return this.$refs.audio;
    }
  },
  methods: {
    play: function play() {
      this.audio.play();
    },
    pause: function pause() {
      this.audio.pause();
    },
    toggleAutoplay: function toggleAutoplay() {
      this.autoplay = !this.autoplay;
    }
  }
});

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(118)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  "data-v-5bb44c48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(968),
  /* scopeId */
  "data-v-411f9fe2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(964),
  /* scopeId */
  "data-v-29b8d24c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(113)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(969),
  /* scopeId */
  "data-v-4128c6aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)
__webpack_require__(114)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(970),
  /* scopeId */
  "data-v-4bcebef8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  "data-v-d84fbe24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  "data-v-551d05c7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(961),
  /* scopeId */
  "data-v-1e7af362",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  "data-v-f4840512",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)
__webpack_require__(123)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  "data-v-7ec2c3b3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(122)
__webpack_require__(121)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  "data-v-780cdbcf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(960),
  /* scopeId */
  "data-v-0f5f7199",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(967),
  /* scopeId */
  "data-v-3e5df696",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(127)
__webpack_require__(126)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  "data-v-89a3dee2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(966),
  /* scopeId */
  "data-v-38a366a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(965),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(102)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(959),
  /* scopeId */
  "data-v-08ea9e06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(116)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(971),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 959:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "post-detail"
  }, [_c('div', {
    class: _vm.wrapBackground,
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loading-msg link-ellipsis"
  }, [_vm._v("\n      正在載入網址："), _c('a', {
    attrs: {
      "href": _vm.post.iframe,
      "target": "_blank",
      "alt": _vm.post.iframe
    }
  }, [_vm._v(_vm._s(_vm.post.iframe || 'N/A') + " ")])]) : _c('div', {
    staticClass: "loading-msg link-ellipsis"
  }, [_vm._v("\n      共編/作品網址："), _c('a', {
    attrs: {
      "href": _vm.post.iframe,
      "target": "_blank",
      "alt": _vm.post.iframe
    }
  }, [_vm._v(_vm._s(_vm.post.iframe || '未填寫') + " ")])]), _vm._v(" "), (_vm.loadIframe) ? _c('iframe', {
    attrs: {
      "id": "iframe",
      "src": _vm.src,
      "frameborder": "1"
    },
    on: {
      "load": function($event) {
        _vm.isLoading = false
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "info"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.post.name))]), _vm._v(" "), _c('h3', [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "name": (_vm.isLovedByMe ? 'heart' : 'heart-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleHeart($event)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.heartCount))])], 1), _vm._v(" "), _c('h3', [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "name": (_vm.isStaredByMe ? 'star' : 'star-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStar($event)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.starCount))])], 1), _vm._v(" "), _c('h3', [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "id": "location",
      "name": "map-o"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goMap(_vm.post.table)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.post.table ? _vm.post.table + '桌' : '未選桌號'))])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    attrs: {
      "id": "desc-block"
    }
  }, [_vm._l((_vm.post.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "type": "gray",
        "color": "white"
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.post.desc))])], 2), _vm._v(" "), _c('span', {
    attrs: {
      "id": "gutter"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "link-ellipsis",
    attrs: {
      "id": "ul-block"
    }
  }, [_c('b', [_c('li', [_vm._v("提案者：" + _vm._s(_vm.post.host))])]), _vm._v(" "), _c('b', [_c('li', [_vm._v("參與者： "), _vm._l((_vm.post.teammates), function(t) {
    return _c('span', [_vm._v(_vm._s(t) + ", ")])
  })], 2)]), _vm._v(" "), _c('li', [_vm._v("專案狀態：" + _vm._s(_vm.post.status))]), _vm._v(" "), _c('li', [_vm._v("\n          專案介紹 URL: "), _c('a', {
    attrs: {
      "href": _vm.post.iframe,
      "target": "_blank",
      "alt": _vm.post.iframe
    }
  }, [_vm._v(_vm._s(_vm.post.iframe || '未填寫'))])]), _vm._v(" "), _c('li', [_vm._v("\n          GitHub: "), (_vm.post.git) ? _c('a', {
    attrs: {
      "href": 'https://github.com/' + _vm.post.git,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.post.git))]) : _c('span', [_vm._v("未填寫")])]), _vm._v(" "), _c('li', [_vm._v("聯絡方式：" + _vm._s(_vm.post.contact || '無'))]), _vm._v(" "), _c('li', [_vm._v("企業獎調查：" + _vm._s((_vm.post.awards ? ("1." + (_vm.post.awards[0]) + "  2." + (_vm.post.awards[1] || '無')) : '無')))]), _vm._v(" "), _c('li', [_vm._v("最近更新："), _c('time', [_vm._v(_vm._s(new Date(_vm.post.timestamp).toLocaleString()))])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 960:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('el-form', {
    ref: "newPost",
    attrs: {
      "model": _vm.newPost,
      "rules": _vm.rules,
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingUpdate),
      expression: "loadingUpdate"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "專案名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "3至15字元",
      "width": "100%",
      "size": "small"
    },
    model: {
      value: (_vm.newPost.name),
      callback: function($$v) {
        _vm.newPost.name = $$v
      },
      expression: "newPost.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "桌號",
      "prop": "table"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "請選擇目前所在桌號",
      "size": "small"
    },
    model: {
      value: (_vm.newPost.table),
      callback: function($$v) {
        _vm.newPost.table = $$v
      },
      expression: "newPost.table"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "尋找中",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.tables), function(i) {
    return (i !== '0') ? _c('el-option', {
      key: i,
      attrs: {
        "label": i + '桌',
        "value": i
      }
    }) : _vm._e()
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企業獎調查（至多2個，調查至3pm截止，詳細流程：https://goo.gl/oWutMs）",
      "prop": "awards"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "min": 0,
      "max": 2
    },
    model: {
      value: (_vm.newPost.awards),
      callback: function($$v) {
        _vm.newPost.awards = $$v
      },
      expression: "newPost.awards"
    }
  }, _vm._l((_vm.awardOptions), function(awardOpt) {
    return _c('el-checkbox', {
      key: awardOpt,
      attrs: {
        "label": awardOpt,
        "disabled": false
      }
    }, [_vm._v(_vm._s(awardOpt))])
  }))], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "與會者編號",
      "prop": "host"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "visible-arrow": true,
      "content": "格式：#999"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "提案人"
    },
    model: {
      value: (_vm.newPost.host),
      callback: function($$v) {
        _vm.newPost.host = $$v
      },
      expression: "newPost.host"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "專案成員",
      "prop": "teammates"
    }
  }, [_vm._l((_vm.newPost.teammates), function(teammate) {
    return _c('el-tag', {
      key: teammate,
      attrs: {
        "closable": true,
        "type": "gray",
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleDeleteTeammate(teammate)
        }
      }
    }, [_vm._v(_vm._s(teammate))])
  }), _vm._v(" "), (_vm.inputVisibleTeammate) ? _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.teammates || _vm.newPost.teammates.length < 15),
      expression: "!newPost.teammates || newPost.teammates.length < 15"
    }],
    ref: "saveTeammateInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleNewTeammateConfirm
    },
    nativeOn: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleNewTeammateConfirm($event)
      }
    },
    model: {
      value: (_vm.inputNewTeammate),
      callback: function($$v) {
        _vm.inputNewTeammate = $$v
      },
      expression: "inputNewTeammate"
    }
  }) : _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.teammates || _vm.newPost.teammates.length < 15),
      expression: "!newPost.teammates || newPost.teammates.length < 15"
    }],
    staticClass: "button-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.showNewTeammateInput
    }
  }, [_vm._v("+ 新增成員")])], 2)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "專案聯絡方式（公開）",
      "prop": "contact"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Discord ID, 臉書, email等，自由選填，多筆請以逗號分隔"
    },
    model: {
      value: (_vm.newPost.contact),
      callback: function($$v) {
        _vm.newPost.contact = $$v
      },
      expression: "newPost.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "標籤",
      "prop": "tags"
    }
  }, [_vm._l((_vm.newPost.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": true,
        "type": "gray",
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleDeleteTag(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), (_vm.inputVisible) ? [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "value": _vm.tagListTooltip.length > 0,
      "placement": "right-start",
      "visible-arrow": true
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.tagListTooltip)
    },
    slot: "content"
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.tags || _vm.newPost.tags.length < 3),
      expression: "!newPost.tags || newPost.tags.length < 3"
    }],
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleNewTagConfirm
    },
    nativeOn: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleNewTagConfirm($event)
      }
    },
    model: {
      value: (_vm.inputNewTag),
      callback: function($$v) {
        _vm.inputNewTag = $$v
      },
      expression: "inputNewTag"
    }
  })], 1)] : _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.tags || _vm.newPost.tags.length < 3),
      expression: "!newPost.tags || newPost.tags.length < 3"
    }],
    staticClass: "button-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.showNewTagInput
    }
  }, [_vm._v("+ 新增標籤")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "進度狀態",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.newPost.status),
      callback: function($$v) {
        _vm.newPost.status = $$v
      },
      expression: "newPost.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "徵人"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "趕工"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "完工"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "放棄"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "企業獎",
      "prop": "award"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.newPost.award),
      callback: function($$v) {
        _vm.newPost.award = $$v
      },
      expression: "newPost.award"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "無"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "中信金控"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "北市交通局"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "微軟"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "HITCON"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "經濟部"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "農委會"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "威盛電子"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.wordCountMsg,
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "width": "20rem",
      "placeholder": "請簡要介紹專案內容（100字以內，約前30字會顯示於卡片預覽）"
    },
    model: {
      value: (_vm.newPost.desc),
      callback: function($$v) {
        _vm.newPost.desc = $$v
      },
      expression: "newPost.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "GitHub",
      "prop": "git"
    }
  }, [_c('el-input', {
    staticClass: "url",
    attrs: {
      "placeholder": "john666/my-project"
    },
    model: {
      value: (_vm.newPost.git),
      callback: function($$v) {
        _vm.newPost.git = $$v
      },
      expression: "newPost.git"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("github.com/")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "專案介紹 URL",
      "prop": "iframe"
    }
  }, [_c('el-input', {
    staticClass: "url",
    attrs: {
      "placeholder": "請輸入可預覽之網頁網址（下方可測試）"
    },
    on: {
      "change": function($event) {
        _vm.loadIframe = false;
        _vm.isLoadingIframe = false
      }
    },
    model: {
      value: (_vm.newPost.iframe),
      callback: function($$v) {
        _vm.newPost.iframe = $$v
      },
      expression: "newPost.iframe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [(!_vm.loadIframe) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.loadIframe = true;
        _vm.isLoadingIframe = true
      }
    }
  }, [_vm._v("測試 URL 預覽")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingIframe) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }]
  }, [_vm._v("\n               "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.loadIframe) ? _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoadingIframe),
      expression: "!isLoadingIframe"
    }],
    attrs: {
      "src": _vm.newPost.iframe,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": function($event) {
        _vm.isLoadingIframe = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v("已知支援預覽：\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://hackmd.io/new"
    }
  }, [_vm._v("HackMD")]), _vm._v("、\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.google.com.tw/intl/zh-TW/docs/about/"
    }
  }, [_vm._v("Google Doc")]), _vm._v("、\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/"
    }
  }, [_vm._v("YouTube")])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('newPost')
      }
    }
  }, [_vm._v("更新")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sponsor flex-container"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Sponsors")]), _vm._v(" "), _vm._l((_vm.records), function(sponsor) {
    return (sponsor['商標png'] !== undefined) ? _c('span', {
      key: sponsor.id
    }, [_c('a', {
      attrs: {
        "href": sponsor['URL'],
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": sponsor['商標png'][0].thumbnails.small.url,
        "alt": sponsor['贊助商']
      }
    })])]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "announcement"
  }, [(_vm.announcements[0] || !_vm.enableHistory) ? _c('div', [_c('transition', {
    attrs: {
      "name": "el-zoom-in-center",
      "mode": "out-in"
    }
  }, [(!_vm.showHistory) ? _c('el-card', {
    key: "single",
    staticClass: "box-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "zone"
    }
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.title['.value']))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "detail"
    }
  }, [_vm._v(_vm._s(_vm.detail['.value']))]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.enableHistory) ? _c('el-button', {
    staticClass: "show-history",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showHistory = true
      }
    }
  }, [_vm._v("所有公告")]) : _vm._e()], 1)])]) : _c('el-card', {
    key: "list"
  }, _vm._l((_vm.announcements), function(announcement, index) {
    return _c('el-button', {
      key: index,
      staticClass: "button",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.clickIndex = index;
          _vm.showHistory = false;
        }
      }
    }, [_vm._v("\n          " + _vm._s(announcement.title) + "\n        ")])
  }))], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 963:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('banner'), _vm._v(" "), _c('router-view', {
    staticClass: "main",
    on: {
      "loaded": _vm.loaded
    }
  }), _vm._v(" "), (_vm.config.sponsor) ? _c('sponsor') : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "ready": _vm.ready
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 964:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "expo"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": "",
      "maxlength": 3,
      "placeholder": "請輸入桌號",
      "icon": "circle-close",
      "on-icon-click": _vm.clear,
      "size": "large",
      "type": "number",
      "pattern": "[0-9]*",
      "inputmode": "numeric"
    },
    model: {
      value: (_vm.table),
      callback: function($$v) {
        _vm.table = $$v
      },
      expression: "table"
    }
  }), _vm._v(" "), (_vm.matchedPosts.length === 0) ? _c('h1', [_c('span', [_vm._v(_vm._s((_vm.table === '' ? '請輸入桌號' : '找不到專案')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matchedPosts), function(post) {
    return [_c('el-card', {
      staticClass: "box-card",
      attrs: {
        "body-style": "height:inherit;padding:0px"
      }
    }, [_c('postsummary', {
      attrs: {
        "title": post.name,
        "subtitle": (post.author || '').split('@')[0] + ' @ ' + post.table + '桌',
        "description": ("(" + (post.table) + "桌) " + (post.desc)),
        "table": Number(post.table),
        "postKey": post['.key'],
        "authorId": post.uid,
        "starCount": post.starCount,
        "stars": post.stars,
        "heartCount": post.heartCount,
        "hearts": post.hearts,
        "tags": post.tags,
        "host": post.host
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myposts"
  }, [(_vm.user !== null) ? [(_vm.isFetching) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }]
  }) : (_vm.myPosts.length === 0) ? _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "新增一個Project!"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.newPostForCurrentUser($event)
      }
    },
    model: {
      value: (_vm.newPostTitle),
      callback: function($$v) {
        _vm.newPostTitle = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "newPostTitle"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.newPostForCurrentUser
    }
  }, [_vm._v("建立")])], 1) : _c('div', [_c('editor', {
    attrs: {
      "postData": _vm.myPosts[0]
    },
    on: {
      "cancel": function($event) {
        _vm.$emit('close')
      }
    }
  })], 1)] : _c('p', [_vm._v("錯誤：請先登入！")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mapview"
  }, [_c('svg', {
    ref: "svg",
    staticClass: ".svg-pan-zoom_viewport",
    attrs: {
      "id": "svg-map",
      "viewBox": '0 0 ' + _vm.map.map_width + ' ' + _vm.map.map_height
    }
  }, [_c('g', {
    staticClass: "svg-pan-zoom_viewport",
    on: {
      "touchmove": function($event) {
        _vm.setFocus(0)
      }
    }
  }, [_c('image', {
    attrs: {
      "xlink:href": __webpack_require__(148),
      "x": 0,
      "y": 0,
      "width": _vm.map.map_width,
      "height": _vm.map.map_height
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "noSeatZone"
    }
  }, [_c('text', {
    attrs: {
      "x": "-177",
      "y": "359"
    }
  }, [_vm._v("\n        未選座位的專案\n      ")]), _vm._v(" "), _c('rect', {
    attrs: {
      "fill": "none",
      "stroke": "red",
      "x": "-180",
      "y": "370",
      "width": 3 * 30 + 30,
      "height": Math.round(_vm.tablePosts[0].length / 3) * 30 + 60,
      "rx": "1.5"
    }
  })]), _vm._v(" "), _vm._l((_vm.tablePosts[0]), function(post, index) {
    return [_c('el-tooltip', {
      attrs: {
        "placement": "top",
        "effect": "light",
        "popper-class": "mypopper"
      }
    }, [_c('div', {
      slot: "content"
    }, [_c('postsummary', {
      attrs: {
        "title": post.name,
        "subtitle": (post.author || '').split('@')[0],
        "description": post.desc + ' (' + post.table + '桌)',
        "authorId": post.uid,
        "starCount": post.starCount,
        "heartCount": post.heartCount,
        "stars": post.stars,
        "hearts": post.hearts,
        "tags": post.tags
      },
      on: {
        "tagClicked": function($event) {
          _vm.$emit('searchTag', $event)
        }
      }
    })], 1), _vm._v(" "), _c('circle', {
      staticClass: "tableCircle noSeat cursor-pointer",
      class: {
        blinkTable: post.status == _vm.blinkStatus
      },
      attrs: {
        "cx": (_vm.getX(0) + _vm.getNoSeatXY('dx', index)),
        "cy": (_vm.getY(0) + _vm.getNoSeatXY('dy', index)),
        "r": "10"
      },
      on: {
        "click": function($event) {
          _vm.onClick(0)
        }
      }
    })])]
  }), _vm._v(" "), _vm._l((_vm.tablePosts), function(post, index) {
    return (index > 0) ? [_c('text', {
      staticClass: "tableText",
      attrs: {
        "dx": (index ? _vm.getX(index) : null),
        "dy": (index ? _vm.getY(index) : null) + 4
      }
    }, [_vm._v("\n      " + _vm._s(post.length) + "\n      ")]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "value": index === _vm.focus,
        "placement": "top",
        "effect": "light",
        "popper-class": "mypopper"
      }
    }, [_c('div', {
      slot: "content"
    }, [_vm._l((post), function(postummary, index) {
      return [_c('postsummary', {
        attrs: {
          "title": postummary.name,
          "subtitle": (postummary.author || '').split('@')[0],
          "description": postummary.desc + ' (' + postummary.table + '桌)',
          "postKey": postummary['.key'],
          "authorId": postummary.uid,
          "starCount": postummary.starCount,
          "heartCount": postummary.heartCount,
          "stars": postummary.stars,
          "hearts": postummary.hearts,
          "tags": postummary.tags
        },
        on: {
          "tagClicked": function($event) {
            _vm.$emit('searchTag', $event)
          }
        }
      }), _vm._v(" "), ((index + 1) != post.length) ? _c('hr') : _vm._e()]
    })], 2), _vm._v(" "), _c('circle', {
      staticClass: "tableCircle cursor-pointer",
      class: ( _obj = {
        blinkTable: _vm.getTableStatus(post).indexOf(_vm.blinkStatus) > -1
      }, _obj[_vm.getStatus(_vm.blinkStatus)] = true, _obj ),
      attrs: {
        "cx": (index ? _vm.getX(index) : null),
        "cy": (index ? _vm.getY(index) : null),
        "r": "10"
      },
      on: {
        "click": function($event) {
          _vm.onClick(index)
        },
        "mouseenter": function($event) {
          _vm.setFocus(index)
        },
        "touchstart": function($event) {
          _vm.setFocus(index)
        }
      }
    })])] : _vm._e()
    var _obj;
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "legand"
  }, [_c('svg', {
    attrs: {
      "height": "2em",
      "width": "5em"
    }
  }, [_c('text', {
    attrs: {
      "x": "0.4em",
      "y": "1em"
    }
  }, [_vm._v("點擊篩選")])]), _vm._v(" "), _vm._l((['徵人', '趕工', '完工', '放棄']), function(symble) {
    return _c('svg', {
      attrs: {
        "height": "1.5em",
        "width": "5em"
      },
      on: {
        "mouseenter": function($event) {
          _vm.setBlinkStatus(true, symble)
        },
        "touchstart": function($event) {
          _vm.setBlinkStatus(true, symble)
        }
      }
    }, [_c('circle', {
      class: [_vm.getColor(symble), 'cursor-pointer'],
      attrs: {
        "r": "7",
        "cx": "1em",
        "cy": "0.7em"
      }
    }), _vm._v(" "), _c('text', {
      staticClass: "cursor-pointer",
      attrs: {
        "x": "2em",
        "y": "1em"
      }
    }, [_vm._v(_vm._s(symble))])])
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "height": "1.5em",
      "width": "5em"
    },
    on: {
      "mousemove": function($event) {
        _vm.setBlinkStatus(false, '全部')
      },
      "touchstart": function($event) {
        _vm.setBlinkStatus(false, '全部')
      }
    }
  }, [_c('circle', {
    staticClass: "tableCircle cursor-pointer",
    attrs: {
      "r": "7",
      "cx": "1em",
      "cy": "0.7em"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "cursor-pointer",
    attrs: {
      "x": "2em",
      "y": "1em"
    }
  }, [_vm._v("全部")])])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "zoomBtnContainer"
    }
  }, [_c('li', [_c('el-button', {
    attrs: {
      "id": "zoomInBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.zoomIn()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-button', {
    attrs: {
      "id": "zoomOutBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.zoomOut()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "minus"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-button', {
    attrs: {
      "id": "zoomResetBtn"
    },
    on: {
      "click": function($event) {
        _vm.resetPanZoom()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrows-alt"
    }
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fullmapview"
  }, [_c('svg', {
    ref: "svg",
    staticClass: ".svg-pan-zoom_viewport",
    attrs: {
      "id": "svg-map",
      "viewBox": '0 0 ' + _vm.map.map_width + ' ' + _vm.map.map_height
    }
  }, [_c('image', {
    attrs: {
      "xlink:href": __webpack_require__(146),
      "x": 0,
      "y": 0,
      "width": _vm.map.map_width,
      "height": _vm.map.map_height
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "zoomBtnContainer"
    }
  }, [_c('li', [_c('el-button', {
    attrs: {
      "id": "zoomInBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.zoomIn()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-button', {
    attrs: {
      "id": "zoomOutBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.zoomOut()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "minus"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-button', {
    attrs: {
      "id": "zoomResetBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.resetZoom();
        _vm.panZoomObj.resetPan()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrows-alt"
    }
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 968:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "askMentor"
    }
  }, [_c('h1', [_vm._v("我要向 Mentor 提問")]), _vm._v(" "), _c('p', [_vm._v("註：Mentor 須在場並登入才會查看")]), _vm._v(" "), _c('p', [_vm._v("若能提供幫助，將至專案位置回答。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    ref: "question",
    attrs: {
      "model": _vm.question,
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "xs": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代表專案 編號",
      "prop": "projectId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "專案編號（提案人編號）",
      "maxlength": 3
    },
    model: {
      value: (_vm.question.projectId),
      callback: function($$v) {
        _vm.question.projectId = $$v
      },
      expression: "question.projectId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "目標 Mentor 編號",
      "prop": "mentorId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "請查看 Mentor 列表的編號",
      "maxlength": 3
    },
    model: {
      value: (_vm.question.mentorId),
      callback: function($$v) {
        _vm.question.mentorId = $$v
      },
      expression: "question.mentorId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "問題 主旨",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "3至10字元",
      "maxlength": 10
    },
    model: {
      value: (_vm.question.title),
      callback: function($$v) {
        _vm.question.title = $$v
      },
      expression: "question.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "問題 簡介",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "請簡短說明問題內容（100字以內）",
      "autosize": {
        minRows: 2,
        maxRows: 10
      },
      "maxlength": 100
    },
    model: {
      value: (_vm.question.description),
      callback: function($$v) {
        _vm.question.description = $$v
      },
      expression: "question.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.askQuestion()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetQuestion()
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('p', [_vm._v("登入才可以提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liveAwards"
    }
  }, [_c('h1', [_vm._v("企業獎即時分流")]), _vm._v(" "), _c('p', [_vm._v("各企業獎報名數量限制為 20 專案，若超額將由各企業參考 HackingMap 專案介紹決定。")]), _vm._v(" "), _c('p', [_vm._v("因各企業獎的名額有限，可參考即時組數調整報名方向，提高獲獎機會")]), _vm._v(" "), _vm._l((_vm.awards), function(award, index) {
    return [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "center",
        "align": "middle",
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12,
        "xs": 20
      }
    }, [_c('div', {
      attrs: {
        "id": "counter"
      }
    }, [_c('h3', [_vm._v(" " + _vm._s(award) + "：" + _vm._s(_vm.awardsLength[index]) + " ")]), _vm._v(" "), _c('el-progress', {
      attrs: {
        "percentage": _vm.awardsLength[index] / 20 * 100,
        "show-text": false,
        "stroke-width": 8,
        "status": _vm.awardsLength[index] >= 20 ? 'exception' : ''
      }
    })], 1)])], 1)]
  }), _vm._v(" "), _c('span', [_vm._v("規則"), _c('el-input', {
    model: {
      value: (_vm.regex),
      callback: function($$v) {
        _vm.regex = $$v
      },
      expression: "regex"
    }
  })], 1), _vm._v(" "), _c('ol', _vm._l((_vm.postWithoutHost), function(post) {
    return _c('li', [_vm._v(_vm._s(post))])
  }))], 2)
},staticRenderFns: []}

/***/ }),

/***/ 970:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      ready: _vm.ready
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "flipLoading",
    attrs: {
      "id": "cover"
    }
  }, [_c('svg', {
    attrs: {
      "id": "logo",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 160 160"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "Rectangle",
      "x": "1",
      "y": "4",
      "width": "158",
      "height": "158",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feOffset', {
    attrs: {
      "dy": "3",
      "input": "SourceAlpha"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "3",
      "result": "blur"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-opacity": "0.161"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "operator": "in",
      "in2": "blur"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip"
    }
  }, [_c('rect', {
    attrs: {
      "width": "160",
      "height": "160"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-1"
  }, [_c('rect', {
    staticClass: "cls-7",
    attrs: {
      "width": "160",
      "height": "160"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group_349",
      "data-name": "Group 349",
      "transform": "translate(-163 -414)"
    }
  }, [_c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ready),
      expression: "!ready"
    }],
    staticClass: "cls-8",
    attrs: {
      "transform": "matrix(1, 0, 0, 1, 163, 414)"
    }
  }, [_c('g', {
    staticClass: "cls-2",
    attrs: {
      "transform": "translate(10 10)"
    }
  }, [_c('rect', {
    staticClass: "cls-5",
    attrs: {
      "width": "140",
      "height": "140",
      "rx": "3"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-6",
    attrs: {
      "x": "1.5",
      "y": "1.5",
      "width": "137",
      "height": "137",
      "rx": "1.5"
    }
  })])]), _vm._v(" "), _c('text', {
    staticClass: "cls-3",
    attrs: {
      "id": "Hacking",
      "transform": "translate(243 503)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-54.719",
      "y": "0"
    }
  }, [_vm._v("Hacking")])]), _vm._v(" "), _c('text', {
    staticClass: "cls-4",
    attrs: {
      "id": "Map",
      "transform": "translate(216 539)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "0",
      "y": "0"
    }
  }, [_vm._v("Map")])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.audioSrc,
      "autoplay": _vm.autoplay,
      "controls": ""
    }
  }, [_vm._v("\n    您的瀏覽器不支援 audio 標籤功能。\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.toggleAutoplay()
      }
    }
  }, [_vm._v("toggle autoplay")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.autoplay),
      expression: "autoplay"
    }]
  }, [_vm._v("autoplay enabled")])])
},staticRenderFns: []}

/***/ }),

/***/ 972:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('x-audio', {
    ref: "xAudio",
    attrs: {
      "audio-src": _vm.audioSrc
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locale),
      expression: "locale"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.locale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.select.locale), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n      " + _vm._s(option) + "\n    ")])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.select.gender), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n      " + _vm._s(option) + "\n    ")])
  })), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.audioSrc,
      "target": "_blank",
      "download": "audio"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticStyle: {
      "width": "500px",
      "height": "100px"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "admin"
    }
  }, [_c('div', {
    attrs: {
      "id": "announcement",
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-row', [_c('h2', [_vm._v("預覽：")]), _vm._v(" "), _c('announcement')], 1), _c('br'), _vm._v(" "), _c('el-row', [_c('h2', [_vm._v("設定：")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.announcement,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ("公告標題 (" + _vm.titleLength + "/15字)"),
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "限10字"
    },
    model: {
      value: (_vm.title['.value']),
      callback: function($$v) {
        var $$exp = _vm.title,
          $$idx = '.value';
        if (!Array.isArray($$exp)) {
          _vm.title['.value'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "title['.value']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ("公告內容 (" + _vm.detailLength + "/50字)"),
      "prop": "detail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "請輸入公告內容"
    },
    model: {
      value: (_vm.detail['.value']),
      callback: function($$v) {
        var $$exp = _vm.detail,
          $$idx = '.value';
        if (!Array.isArray($$exp)) {
          _vm.detail['.value'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "detail['.value']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密碼"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "密碼"
    },
    model: {
      value: (_vm.pwd),
      callback: function($$v) {
        _vm.pwd = $$v
      },
      expression: "pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.updateAnnouncement()
      }
    }
  }, [_vm._v("更新")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 974:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('hackingmap', {
    on: {
      "loaded": function($event) {
        _vm.$emit('loaded')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_c('announcement'), _vm._v(" "), _c('schedule')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isFetching),
      expression: "isFetching"
    }],
    ref: "scroll-area",
    staticClass: "schedule"
  }, [_c('div', {
    staticClass: "steps"
  }, [(_vm.records.length !== 0) ? _c('el-steps', {
    attrs: {
      "space": 100,
      "direction": "vertical",
      "active": _vm.currentEventIndex,
      "process-status": "finish",
      "finish-status": "wait"
    }
  }, [_vm._l((_vm.records), function(record, index) {
    return [_c('el-step', {
      ref: 'step' + index + 'ref',
      refInFor: true
    }, [_c('a', {
      class: (record['連結'] ? 'step_title_link' : ''),
      attrs: {
        "href": record['連結'],
        "target": "_blank"
      },
      slot: "title"
    }, [_vm._v("\n            " + _vm._s(record['大標題']) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "schedule-fa-icon",
      slot: "icon"
    }, [_c('icon', {
      attrs: {
        "name": record['fa-icon'] || _vm.default_icon
      }
    })], 1), _vm._v(" "), _c('div', {
      slot: "description"
    }, [_vm._v("\n            " + _vm._s(_vm.formatDates(record['開始時間'], record['結束時間']))), _c('br'), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.clipSubtitle(record['副標題']))
      }
    })])])]
  })], 2) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hackingmap"
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8,
      "md": 8,
      "sm": 8,
      "xs": 16
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜尋",
      "disabled": _vm.$route.path === '/full_map'
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "query"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "請選擇",
      "size": "large"
    },
    slot: "prepend",
    model: {
      value: (_vm.scope),
      callback: function($$v) {
        _vm.scope = $$v
      },
      expression: "scope"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "all"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "專案名",
      "value": "name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "簡介",
      "value": "desc"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Tag",
      "value": "tags"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "參與者",
      "value": "teammates"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "企業獎",
      "value": "awards"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 8,
      "sm": 8,
      "xs": 8
    }
  }, [_c('el-radio-group', {
    staticClass: "regular-toolbar",
    nativeOn: {
      "change": function($event) {
        _vm.$router.push($event.target.value)
      }
    },
    model: {
      value: (_vm.path),
      callback: function($$v) {
        _vm.path = $$v
      },
      expression: "path"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "/projects"
    }
  }, [_vm._v("列表")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "/map"
    }
  }, [_vm._v("地圖")])], 1), _vm._v(" "), _c('el-select', {
    staticClass: "phone-toolbar",
    on: {
      "change": function($event) {
        _vm.$router.push($event)
      }
    },
    model: {
      value: (_vm.path),
      callback: function($$v) {
        _vm.path = $$v
      },
      expression: "path"
    }
  }, [_c('el-option', {
    key: "projects",
    attrs: {
      "label": "列表",
      "value": "/projects"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "map",
    attrs: {
      "label": "地圖",
      "value": "/map"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 8,
      "sm": 8,
      "xs": 0,
      "id": "sort-radio"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path !== '/map'),
      expression: "$route.path !== '/map'"
    }]
  }, [_vm._v("\n          排序：\n          "), _c('el-radio-group', {
    model: {
      value: (_vm.sortKey),
      callback: function($$v) {
        _vm.sortKey = $$v
      },
      expression: "sortKey"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "timestamp"
    }
  }, [_vm._v("更新")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "hearts"
    }
  }, [_vm._v("創意"), _c('icon', {
    attrs: {
      "name": "heart"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "stars"
    }
  }, [_vm._v("技術"), _c('icon', {
    attrs: {
      "name": "star"
    }
  })], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    attrs: {
      "id": "router-view",
      "filteredPosts": _vm.filteredSortedPosts
    },
    on: {
      "searchTag": function($event) {
        _vm.scope = 'tags';
        _vm.query = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.user !== null) ? [_c('el-button', {
    attrs: {
      "icon": "edit",
      "id": "editBtn",
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showDialog = true
      }
    }
  }, [_vm._v("編輯專案")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "專案編輯",
      "visible": _vm.showDialog,
      "modal": true,
      "size": "large",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('myposts', {
    on: {
      "close": function($event) {
        _vm.showDialog = false
      }
    }
  })], 1)] : [_c('el-button', {
    attrs: {
      "icon": "edit",
      "id": "editBtn",
      "disabled": true,
      "type": "primary",
      "size": "large"
    }
  }, [_vm._v("新增專案")])], _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "HackingMap 功能導覽",
      "visible": _vm.showIntro,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.showIntro = $event
      }
    }
  }, [_c('span', [_c('intro')], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showIntro = false
      }
    }
  }, [_vm._v("關 閉")])], 1)])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oauthlogin"
  }, [(_vm.user !== null) ? [(_vm.user.photoURL) ? _c('div', [_c('img', {
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "src": _vm.user.photoURL,
      "alt": "avatar"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("登出")])] : [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm.enableGoogleLoginFlag) ? [_c('el-button', {
    staticClass: "btn-primary-google",
    attrs: {
      "size": _vm.isPhone ? 'small' : 'large'
    },
    on: {
      "click": _vm.signinWithGoogle
    }
  }, [_c('span', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(147)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Google登入")])])] : _vm._e(), _vm._v(" "), (_vm.enableFacebookLoginFlag) ? [_c('el-button', {
    staticClass: "btn-primary-facebook",
    attrs: {
      "size": _vm.isPhone ? 'small' : 'large'
    },
    on: {
      "click": _vm.signinWithFB
    }
  }, [_c('span', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(145)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Facebook登入")])]), _c('br')] : _vm._e(), _vm._v(" "), (_vm.enableEmailPassLoginFlag) ? [_c('br'), _c('br'), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _c('span', {
    staticStyle: {
      "position": "relative",
      "top": "-0.6rem",
      "background-color": "white"
    }
  }, [_vm._v(" 或 ")]), _vm._v(" "), _c('h3', [_vm._v("以Email登入")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showEmailPassField),
      expression: "!showEmailPassField"
    }],
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showEmailPassField = true
      }
    }
  }, [_vm._v(" 註冊/登入 ")])] : _vm._e()], 2), _vm._v(" "), (_vm.enableEmailPassLoginFlag) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmailPassField),
      expression: "showEmailPassField"
    }]
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("登入信箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "pwd"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-right",
    on: {
      "click": function($event) {
        _vm.showResetBtn = !_vm.showResetBtn
      }
    }
  }, [_c('u', [_vm._v("登入遇到問題？")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signInWithEmailAndPassword
    }
  }, [_vm._v("登入")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("註冊")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResetBtn),
      expression: "showResetBtn"
    }],
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入可正常收信的 email 地址"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendResetMail
    }
  }, [_vm._v("取得密碼重設連結")])])])])])] : _vm._e()], 2)])]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 979:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listview"
  }, [_c('transition-group', {
    staticClass: "flex-container",
    attrs: {
      "name": "el-fade-in",
      "tag": "span"
    }
  }, _vm._l((_vm.filteredPosts), function(p, index) {
    return _c('article', {
      key: p['.key']
    }, [_c('el-card', {
      staticClass: "box-card",
      attrs: {
        "body-style": "height:inherit;padding:0px"
      }
    }, [_c('postsummary', {
      attrs: {
        "title": p.name,
        "subtitle": (p.author || '').split('@')[0] + ' @ ' + p.table + '桌',
        "description": p.desc,
        "table": Number(p.table),
        "postKey": p['.key'],
        "authorId": p.uid,
        "starCount": p.starCount,
        "stars": p.stars,
        "heartCount": p.heartCount,
        "hearts": p.hearts,
        "tags": p.tags,
        "host": p.host
      },
      on: {
        "tagClicked": function($event) {
          _vm.$emit('searchTag', $event)
        }
      }
    })], 1)], 1)
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "custom-class": "larger-dialog",
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('postdetail', {
    attrs: {
      "post": _vm.getPost(_vm.dialogPostKey),
      "isOpen": _vm.dialogVisible
    },
    on: {
      "closeDialog": function($event) {
        _vm.hideDialog()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 980:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "postsummary"
  }, [_c('a', {
    attrs: {
      "href": ("#/map?focus=" + _vm.table)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.table) ? _c('icon', {
    attrs: {
      "id": "location",
      "name": "map-o"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goMap(_vm.table)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "reaction"
  }, [_c('span', {
    staticClass: "raIcon"
  }, [_c('icon', {
    staticClass: "icon fa-icon-pointer",
    attrs: {
      "name": (_vm.isStaredByMe ? 'star' : 'star-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStar($event)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "raCount"
  }, [_vm._v(_vm._s(_vm.starCount))])]), _vm._v(" "), _c('span', {
    staticClass: "reaction"
  }, [_c('span', {
    staticClass: "raIcon"
  }, [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "name": (_vm.isLovedByMe ? 'heart' : 'heart-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleHeart($event)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "raCount"
  }, [_vm._v(_vm._s(_vm.heartCount))])]), _vm._v(" "), _c('a', {
    staticClass: "no-blue-link",
    attrs: {
      "href": '#/projects?id=' + _vm.postKey
    }
  }, [_c('h3', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('a', {
    staticClass: "no-blue-link",
    attrs: {
      "href": '#/projects?id=' + _vm.postKey
    }
  }, [_c('p', {
    staticClass: "description"
  }, [_c('strong', [_vm._v(_vm._s(_vm.host))]), _vm._v("\n      " + _vm._s(_vm.description) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tags",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('el-button', {
      key: _vm.tags.indexOf(tag),
      staticClass: "button-new-tag",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$emit('tagClicked', tag)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag) + "\n    ")])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 981:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "loading-bg scroll-wrapper"
  }, [_c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    attrs: {
      "id": "intro-iframe",
      "src": _vm.url,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": function($event) {
        _vm.isLoaded = true
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 982:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mentor"
    }
  }, [_c('h1', [_vm._v("Mentor 介面")]), _vm._v(" "), _c('h3', [_vm._v("Mentor ID")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "xs": 20
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "請輸入 Mentor ID",
      "maxlength": 3
    },
    model: {
      value: (_vm.mentorId),
      callback: function($$v) {
        _vm.mentorId = $$v
      },
      expression: "mentorId"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("問題集")]), _vm._v(" "), _c('p', [_vm._v("若能提供幫助，可至專案位置回答")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [(_vm.mentorQuestions) ? _c('el-col', {
    attrs: {
      "span": 8,
      "xs": 20
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_vm._l((_vm.mentorQuestions), function(question) {
    return [_c('el-collapse-item', {
      attrs: {
        "title": '專案 #' + question.projectId + '　　問: ' + question.title,
        "name": question['.key']
      }
    }, [_c('div', [_vm._v(_vm._s(question.description))])])]
  })], 2)], 1) : _c('h4', [_vm._v("尚未收到問題")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner vertical-container"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    attrs: {
      "id": "buttons-right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.visible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.loginBtnText))]), _vm._v("  \n\n    "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "id": "dropdown-btn"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n        活動"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, _vm._l((_vm.dropdownItems), function(item) {
    return _c('span', [(item.disabled) ? _c('el-dropdown-item', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(_vm._s(item.text) + " (敬請期待)")]) : _c('a', {
      staticClass: "dropdown-a",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('el-dropdown-item', [_vm._v(_vm._s(item.text))])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.dialogTitle,
      "modal-append-to-body": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('oauthlogin')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hackntu_logo"
  }, [_c('a', {
    attrs: {
      "href": "#/projects"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(149),
      "alt": "hackntu_logo"
    }
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "github-star"
    }
  }, [_c('a', {
    staticClass: "github-button beside-logo",
    attrs: {
      "href": "https://github.com/hackntu/hackingmap",
      "data-icon": "octicon-star",
      "data-show-count": "true",
      "aria-label": "Star hackntu/hackingmap on GitHub"
    }
  }, [_vm._v("Star")])])])
}]}

/***/ })

},[50]);


// WEBPACK FOOTER //
// static/js/app.a6a57199332a2960791b.js